import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminInquiries.supplementSendInquiry;
export const adminSupplementSendInquiryIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const adminSupplementSendInquiryIsSubmittedSelector = (state: RootState) =>
  getState(state).isSubmitted;
